export const convertPageType = pageType => {
  // old: 'home' | 'category' | 'product' | 'checkout' | 'custom'
  // new: 'home' | 'productList' | 'productDetail' | 'cart' | 'custom'
  switch (pageType) {
    case 'category':
      return 'productList'
    case 'product':
      return 'productDetail'
    case 'checkout':
      return 'cart'
    default:
      return pageType
  }
}

export const convertPageTypeToOld = pageType => {
  // new: 'home' | 'productList' | 'productDetail' | 'cart' | 'custom'
  // old: 'home' | 'category' | 'product' | 'checkout' | 'custom'
  switch (pageType) {
    case 'productList':
      return 'category'
    case 'productDetail':
      return 'product'
    case 'cart':
      return 'checkout'
    default:
      return pageType
  }
}
